<template>
    <div id="message_bubble">
        <div class="bubble_text"></div>
    </div>
</template>

<script>
export default {
    name: "Snackbar"
}
</script>

<style scoped>

</style>